import Point from '../../geom/Point'

var OUT_RESULT = new Point(-1, -1);

function CoveredBoundsProjection(bounds, chainedProjection) {
    this._bounds = bounds.clone();
    this._chainedProjection = chainedProjection;
}

CoveredBoundsProjection.prototype.locationToPoint = function(location) {
    if (this.isInCoveredBounds(location)) {
        var point = this._chainedProjection.locationToPoint(location);
        return point;
    }
    return OUT_RESULT;
};

CoveredBoundsProjection.prototype.pointToLocation = function(point) {
    var location = this._chainedProjection.pointToLocation(point);
    return location;
};

CoveredBoundsProjection.prototype.isInCoveredBounds = function(location) {
    if (this._bounds) {
        return this._bounds.contains(location);
    }
};

export default CoveredBoundsProjection;